import { Component, Input, OnDestroy, TemplateRef, ViewChild } from '@angular/core';

import { ICerFormViewType } from './cer-form-view-type.interface';
import { CerAppRouteService } from 'src/cer-app/cer-app-route/cer-app-route.service';
import { UiCommandEvent } from '@ui/cer-ui-types';
import { CerFormView } from '@form/cer-form-view';
import { CerGridComponent } from 'src/cer/cer-grid/cer-grid.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cer-form-view-type-list',
  templateUrl: './cer-form-view-type-list.component.html',
})
export class CerFormViewTypeListComponent implements OnDestroy, ICerFormViewType {
  @ViewChild(TemplateRef<any>) template!: TemplateRef<any>;

  private _view: CerFormView;
  get view(): CerFormView { return this._view; };
  @Input() set view(view: CerFormView) {
    if (view && this._view != view) {
      this._view = view;
      this.viewSubscription = this._view.commandSubscribe(e => this.onCommand(e));
    }
  }

  private viewSubscription: Subscription;
  public ngOnDestroy(): void {
    this.viewSubscription?.unsubscribe();
  }

  public onCommand(e: UiCommandEvent) {
    if (this.list != null && this.list.id != e.appComponent?.id) {
      this.list.onViewCommand(e);
    }
  }

  protected onComponentCommand(e: UiCommandEvent) {
    if (this.view != null) {
      this.view.triggerCommand(e);
    }
  }

  public list: CerGridComponent = null;
  @ViewChild(CerGridComponent, { static: false }) set setViewChildList(list: CerGridComponent) {
    if (list && this.list != list) {
      this.list = list;
      if (this.view != null) {
        this.view.appComponent = list;
      }
    }
  }

  constructor(private r: CerAppRouteService) {
    r.setIsLoading(false);
  }

}

